import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faSpinner } from "@fortawesome/free-solid-svg-icons"
import { SpinWheel } from 'spin-wheel-game';

// const segments = [
//   { segmentText: '1', segColor: '#981B66' },
//   { segmentText: '2', segColor: '#17BF4E' },
//   { segmentText: '3', segColor: '#FFCA00' },
//   { segmentText: '4', segColor: '#00AFFF' },
//   { segmentText: '5', segColor: '#FF3C00' },
//   { segmentText: '6', segColor: '#0529F3' },
//   { segmentText: '7', segColor: '#03B446' },
//   { segmentText: '8', segColor: '#0529F3' },
//   { segmentText: '9', segColor: '#E8C030' },
//   { segmentText: '10', segColor: '#BF1D12' },
//   { segmentText: '11', segColor: '#0529F3' },
// ];

const Test1 = ({spin, setSpin, setPoints, widget}) => {
  const canvasRef = useRef(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [totalPoints, setTotalPoints] = useState(
    parseInt(localStorage.getItem("userPoints")) || 0
  );
  const [rotation, setRotation] = useState(0);
  const [currentSpeed, setCurrentSpeed] = useState(0);
  // const segments = ["10", "20", "30", "40", "50"];
  const segColors = ["#EE4040", "#F0CF50", "#815CD1", "#3DA5E0", "#34A24F"];
  const rewards = {
    "10": 10,
    "20": 20,
    "30": 30,
    "40": 40,
    "50": 50,
  };

  function generateSegments(input) {
    if(input){
      const colors = [
        '#981B66', '#17BF4E', '#FFCA00', '#00AFFF', '#FF3C00',
        '#0529F3', '#03B446', '#0529F3', '#E8C030', '#BF1D12', '#0529F3'
      ];
    
      return input?.split(',').map((num, index) => ({
        segmentText: num,
        segColor: colors[index % colors.length] // Cycle through colors
      }));
    }
  }
  
  // const input = "1,2,3,4,5,6,7,8,9,10";
  // const segments = generateSegments(input);
  // console.log('segments',segments);
  

  // const drawWheel = () => {
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");
  //   const width = canvas.width;
  //   const height = canvas.height;
  //   const arcSize = (2 * Math.PI) / segments.length;

  //   ctx.clearRect(0, 0, width, height);
  //   ctx.strokeStyle = "black";
  //   ctx.lineWidth = 2;

  //   for (let i = 0; i < segments.length; i++) {
  //     const angle = i * arcSize;
  //     ctx.beginPath();
  //     ctx.fillStyle = segColors[i];
  //     ctx.moveTo(width / 2, height / 2);
  //     ctx.arc(width / 2, height / 2, width / 2, angle, angle + arcSize, false);
  //     ctx.lineTo(width / 2, height / 2);
  //     ctx.fill();
  //     ctx.stroke();

  //     // Draw text
  //     ctx.save();
  //     ctx.translate(
  //       width / 2 + Math.cos(angle + arcSize / 2) * (width / 3),
  //       height / 2 + Math.sin(angle + arcSize / 2) * (height / 3)
  //     );
  //     ctx.rotate(angle + arcSize / 2);
  //     ctx.fillStyle = "white";
  //     ctx.textAlign = "center";
  //     ctx.font = "bold 16px Arial";
  //     ctx.fillText(segments[i], 0, 0);
  //     ctx.restore();
  //   }
  // };

  // const spinWheel = () => {
  //   if (isSpinning) return;
  //   setIsSpinning(true);
  //   setSpin(true);

  //   const randomSegment = Math.floor(Math.random() * segments.length);
  //   const spins = Math.floor(Math.random() * 5) + 5; // Minimum 5 spins
  //   const finalAngle =
  //     spins * 360 + randomSegment * (360 / segments.length) + 360 / segments.length / 2;

  //   let currentSpeed = 20; // Initial speed
  //   const deceleration = 0.2; // Gradual deceleration

  //   const spinInterval = setInterval(() => {
  //     setRotation((prev) => (prev + currentSpeed) % 360);
  //     currentSpeed -= deceleration;

  //     if (currentSpeed <= 0) {
  //       clearInterval(spinInterval);
  //       setIsSpinning(false);
  //       setSpin(false);

  //       const winningIndex = Math.floor(((finalAngle % 360) + 360) % 360 / (360 / segments.length));
  //       const winner = segments[winningIndex];
  //       const points = rewards[winner];

  //       setTotalPoints((prevPoints) => {
  //         const newTotal = prevPoints + points;
  //         localStorage.setItem("userPoints", newTotal);
  //         return newTotal;
  //       });


  //       setPoints(points)


  //       // setTimeout(() => {
  //       //   alert(`Congratulations! You won ${winner} and earned ${points} points.`);
  //       // }, 500);
  //     }
  //   }, 30);
  // };

  // useEffect(() => {
  //   drawWheel();
  // }, [rotation]);

  const handleSpinFinish = (result) => {
    console.log(`Spun to: ${result}`);
    setPoints(result)
    setSpin(false);
  };

  return (
    widget?.widget.wheelArr&&<div className={"ml-0-mob"}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // justifyContent: "center",
        height: "450px",
        textAlign: "center",
        borderRadius: '12px',
        position: 'relative',
        width: '350px',
        marginTop: '34px',
        marginBottom: '52px',
        color: 'white',
        // marginLeft: '50px',
        position: 'absolute',
        backgroundImage: `url('https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/5c169aa6-7c2a-473e-6241-3ce2c761c700/walletly')`, backgroundSize: 'cover', backgroundPosition: 'center'
      }}
    >
      {console.log('widget123',widget?.widget.wheelArr)}
      {console.log('widget1234',generateSegments(widget?.widget.wheelArr))}
      
      <img style={{position: 'relative', top: '173px'}} width={50} src="https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/8333edf6-f57e-4de5-9c7b-46ee9b4c2a00/walletly" />
      <div className="spintext">Play the game, earn the points<br/>IT’S THE MOMENT</div>
      {widget?.widget.wheelArr&&<SpinWheel
          // segments={segments}
          segments={generateSegments(widget?.widget.wheelArr)}
          onFinished={handleSpinFinish}
          primaryColor="black"
          contrastColor="white"
          buttonText="Spin"
          arrowLocation="center"
          showTextOnSpin={true}
          isSpinSound={false}
          size={110}
          showButton={true}
          style={{marginBottom: '50px'}}
        />}
    </div>
  );
};

export default Test1;
